import { Analytics } from '@/app/libs/analytics/instance';
import { FeaturesRequest } from '@/app/libs/sentry/types/features';
import { captureException } from '@/app/libs/sentry/utils/exception';

interface EventParams<T = object> {
  options?: T;
  name: string;
  type: string;
  label: string;
  value?: string;
}

export function event({ name, type, label, value, options }: EventParams) {
  try {
    Analytics.event(name, { value, event_label: label, event_category: type, ...options });
  } catch (error) {
    if (error instanceof Error) {
      captureException(error, FeaturesRequest.ANALYTICS, { name, type, label, value, ...options });
    }
  }
}
